export const adTranslations = {
    en: { adSimulation: 'Ad Simulation (728x90)' },
    pt: { adSimulation: 'Simulação de Anúncio (728x90)' },
    es: { adSimulation: 'Simulación de Anuncio (728x90)' },
    fr: { adSimulation: 'Simulation de Publicité (728x90)' },
    de: { adSimulation: 'Anzeigensimulation (728x90)' },
    it: { adSimulation: 'Simulazione di Annuncio (728x90)' },
    ru: { adSimulation: 'Моделирование Рекламы (728x90)' },
    zh: { adSimulation: '广告模拟 (728x90)' },
    ja: { adSimulation: '広告シミュレーション (728x90)' },
    ko: { adSimulation: '광고 시뮬레이션 (728x90)' },
    hi: { adSimulation: 'विज्ञापन सिमुलेशन (728x90)' },
    ar: { adSimulation: 'محاكاة الإعلان (728x90)' },
    tr: { adSimulation: 'Reklam Simülasyonu (728x90)' },
    nl: { adSimulation: 'Advertentiesimulatie (728x90)' },
    sv: { adSimulation: 'Annonsimulering (728x90)' },
    no: { adSimulation: 'Annonsesimulering (728x90)' },
    pl: { adSimulation: 'Symulacja Reklamy (728x90)' },
    he: { adSimulation: 'סימולציית מודעה (728x90)' },
    fi: { adSimulation: 'Mainossimulaatio (728x90)' },
    el: { adSimulation: 'Προσομοίωση Διαφήμισης (728x90)' },
    da: { adSimulation: 'Annonce-Simulering (728x90)' },
  };
  